import Cookies from 'js-cookie'

export const handleFavoriteClick = (
  event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
  announceId: string,
  setIsFavorite: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  event.stopPropagation()
  event.preventDefault()

  let favorites
  try {
    favorites = JSON.parse(Cookies.get('MyFavorites') || '{}')
  } catch (e) {
    favorites = {}
  }

  if (favorites[announceId]) {
    delete favorites[announceId]
    setIsFavorite(false)
  } else {
    favorites[announceId] = true
    setIsFavorite(true)
  }

  Cookies.set('MyFavorites', JSON.stringify(favorites), { expires: 365 })
}
